export default __webpack_public_path__ + "static/media/117.319eff38.png";